<div class="row">
  <div class="col-1">
    <div class="text-muted small mb-1">{{ 'pages.tables.machine.status' | translate }}</div>
    <div class="span badge" [ngClass]="'status-badge-' + statusClass(getMachine().status!)">{{ ('statuses.' + getMachine().status) | translate }}</div>
  </div>
  <div  class="col-2">
    <div class="text-muted small mb-1">{{ 'pages.tables.machine.current_batch' | translate }}</div>
    <div class="fw-semibold">{{ getMachine().batch }}</div>
  </div>
  <div class="col-3">
    <div class="text-muted small mb-1">{{ 'pages.tables.machine.updated' | translate }}</div>
    <div class="fw-semibold">{{ getMachine().updated }}</div>
  </div>
  <div class="col-2">
    <div class="text-muted small mb-1">{{ 'pages.tables.machine.start_at' | translate }}</div>
    <div class="fw-semibold">{{ getMachine().alarm }}</div>
  </div>
  <div class="col-2">
    <div class="text-muted small mb-1">{{ 'pages.tables.machine.next_batch' | translate }}</div>
    <div><input [disabled]="getMachine().status != 'DONE'" [(ngModel)]="nextBatch" type="text" placeholder="YYYYMMDD" class="form-control border border-dark-3"></div>
  </div>
  <div class="col-2">
    <div class="text-muted small mb-1">&nbsp;</div>
    <div class="justify-content-around text-end ps-0 pe-0">
      <a (click)="reload()" role="button" class="text-decoration-none text-purple action-buttons"
        [class.disabled]="getMachine().status != 'DONE' && getMachine().status != 'ACTIVE'"
        [style.pointer-events]="getMachine().status != 'DONE' && getMachine().status != 'ACTIVE' ? 'none' : 'auto'"
        [attr.aria-disabled]="getMachine().status != 'DONE' && getMachine().status != 'ACTIVE'">
        <i class="bi bi-arrow-clockwise"></i>Refresh
      </a>
      <a (click)="set()" href="#" class="text-decoration-none text-purple action-buttons"
         [class.disabled]="getMachine().status != 'DONE'"
         [style.pointer-events]="getMachine().status != 'DONE' ? 'none' : 'auto'"
         [attr.aria-disabled]="getMachine().status != 'DONE'">
        <i class="bi bi-play"></i>Run
      </a>
    </div>
  </div>
</div>
